import airConditioner from "../../../icons/structure-view-diagram/air-conditioner.svg?raw";
import battery from "../../../icons/structure-view-diagram/battery.svg?raw";
import biomassPowerPlant from "../../../icons/structure-view-diagram/biomass-power-plant.svg?raw";
import cantenn from "../../../icons/structure-view-diagram/canteen.svg?raw";
import capacitor from "../../../icons/structure-view-diagram/capacitor.svg?raw";
import chp from "../../../icons/structure-view-diagram/chp.svg?raw";
import circle from "../../../icons/structure-view-diagram/circle.svg?raw";
import electricCar from "../../../icons/structure-view-diagram/electric-car.svg?raw";
import electricMeter from "../../../icons/structure-view-diagram/electric-meter.svg?raw";
import electricTower from "../../../icons/structure-view-diagram/electric-tower.svg?raw";
import elevator from "../../../icons/structure-view-diagram/elevator.svg?raw";
import factory from "../../../icons/structure-view-diagram/factory.svg?raw";
import family from "../../../icons/structure-view-diagram/family.svg?raw";
import flash from "../../../icons/structure-view-diagram/flash.svg?raw";
import fuellCell from "../../../icons/structure-view-diagram/fuell-cell.svg?raw";
import gasCogenerationPlant from "../../../icons/structure-view-diagram/gas-cogeneration-plant.svg?raw";
import gasTurbine from "../../../icons/structure-view-diagram/gas-turbine.svg?raw";
import generator from "../../../icons/structure-view-diagram/generator.svg?raw";
import heatPump from "../../../icons/structure-view-diagram/heat-pump.svg?raw";
import heatStorage from "../../../icons/structure-view-diagram/heat-storage.svg?raw";
import officeBlock from "../../../icons/structure-view-diagram/office-block.svg?raw";
import orcSystem from "../../../icons/structure-view-diagram/orc-system.svg?raw";
import questionmark from "../../../icons/structure-view-diagram/questionmark.svg?raw";
import radiatior from "../../../icons/structure-view-diagram/radiator.svg?raw";
import realEstate from "../../../icons/structure-view-diagram/real-estate.svg?raw";
import rectangle from "../../../icons/structure-view-diagram/rectangle.svg?raw";
import residental from "../../../icons/structure-view-diagram/residential.svg?raw";
import solarPanel from "../../../icons/structure-view-diagram/solar-panel.svg?raw";
import user from "../../../icons/structure-view-diagram/user.svg?raw";
import valve from "../../../icons/structure-view-diagram/valve.svg?raw";
import windTurbine from "../../../icons/structure-view-diagram/wind-turbine.svg?raw";

const SVG_TEXTS: Record<string, string> = {
  "/structure-icons/air-conditioner": airConditioner,
  "/structure-icons/battery": battery,
  "/structure-icons/biomass-power-plant": biomassPowerPlant,
  "/structure-icons/canteen": cantenn,
  "/structure-icons/capacitor": capacitor,
  "/structure-icons/chp": chp,
  "/structure-icons/circle": circle,
  "/structure-icons/electric-car": electricCar,
  "/structure-icons/electric-meter": electricMeter,
  "/structure-icons/electric-tower": electricTower,
  "/structure-icons/elevator": elevator,
  "/structure-icons/factory": factory,
  "/structure-icons/family": family,
  "/structure-icons/flash": flash,
  "/structure-icons/fuell-cell": fuellCell,
  "/structure-icons/gas-cogeneration-plant": gasCogenerationPlant,
  "/structure-icons/gas-turbine": gasTurbine,
  "/structure-icons/generator": generator,
  "/structure-icons/heat-pump": heatPump,
  "/structure-icons/heat-storage": heatStorage,
  "/structure-icons/office-block": officeBlock,
  "/structure-icons/orc-system": orcSystem,
  "/structure-icons/questionmark": questionmark,
  "/structure-icons/radiator": radiatior,
  "/structure-icons/real-estate": realEstate,
  "/structure-icons/rectangle": rectangle,
  "/structure-icons/residential": residental,
  "/structure-icons/solar-panel": solarPanel,
  "/structure-icons/user": user,
  "/structure-icons/valve": valve,
  "/structure-icons/wind-turbine": windTurbine
};

/** Returns a data URI for an SVG image used in the StructureViewDiagram. Images are mapped according to imageUrl from node data. */
export function getStructureViewImageUrl(
  image: string,
  color?: string,
  opacity?: number
) {
  const svgText = SVG_TEXTS[image];
  if (!svgText) {
    console.error(
      "Missing StructureViewDiagram image in getStructureViewImageUrl!",
      image
    );
    return undefined;
  }

  const styledSvg = applyStyles(svgText, color, opacity);

  // Encode SVG as a base64 data URI so it can be used as an image src.
  // base64 is used instead of encodeURIComponent because the latter does not
  // encode parentheses, which prematurely close CSS url() when unquoted.
  return `data:image/svg+xml;base64,${btoa(styledSvg)}`;
}

function applyStyles(originalText: string, color?: string, opacity?: number) {
  let styledImageText = originalText;

  if (color) {
    const colorWithoutHash = color.replace("#", "");
    const isHex = /([A-Fa-f0-9]{6}|[A-Fa-f0-9]{3})$/.test(colorWithoutHash);

    if (isHex) {
      styledImageText = styledImageText.replace(
        "#00A79D",
        `#${colorWithoutHash}`
      );
    } else {
      console.error(
        `Invalid color format ${color} in getStructureViewImageUrl for ${originalText}`
      );
    }
  }

  if (typeof opacity !== "undefined") {
    styledImageText = styledImageText.replace(
      'fill-opacity="1"',
      `fill-opacity="${opacity}"`
    );
  }

  return styledImageText;
}
